import {
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { throwUninitializedPropertyAccessException14fok093f3k3t as throwUninitializedPropertyAccessException } from '../../../../../kotlin-kotlin-stdlib/kotlin/internal/ThrowHelpers.mjs';
import {
  ApolloWebSocketClosedException26hvn543pf46i as ApolloWebSocketClosedException,
  ApolloNetworkException3denf70pfh242 as ApolloNetworkException,
  ApolloOfflineException3onq1f2zlyouj as ApolloOfflineException,
} from '../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/exception/Exceptions.mjs';
import { emitAll14ajoawrvg9d0 as emitAll } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/flow/Collect.mjs';
import {
  Builder16nv925388a0q as Builder,
  ApolloResponse1aeginapbuksm as ApolloResponse,
} from '../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/ApolloResponse.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { FlowCollector26clgpmzihvke as FlowCollector } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/flow/FlowCollector.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { flow3tazazxj2t7g4 as flow } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/flow/Builders.mjs';
import { onEach13yrgg7fxnyl6 as onEach } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/flow/Transform.mjs';
import { retryWhenf2aqzvtrvxoo as retryWhen } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/flow/Errors.mjs';
import { Exceptiondt2hlxn7j7vw as Exception } from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import {
  captureStack1fzi4aczwc4hg as captureStack,
  equals2au1ep9vhcato as equals,
  hashCodeq5arwsb9dgti as hashCode,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { FunctionAdapter3lcrrz3moet5b as FunctionAdapter } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/FunctionAdapter.mjs';
import { waitForNetwork170u1djobkhlr as waitForNetwork } from '../network/NetworkMonitor.mjs';
import { Subscription2xxf73xmsvgi0 as Subscription } from '../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Subscription.mjs';
import {
  Companion_getInstancevdtg3uvqmv7f as Companion_getInstance,
  toDuration28gf6ughsr3vf as toDuration,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/time/Duration.mjs';
import { coerceAtMostfyc3emgaderp as coerceAtMost } from '../../../../../kotlin-kotlin-stdlib/kotlin/ranges/_Ranges.mjs';
import { DurationUnit_SECONDS_getInstancesbkvvo7sip2d as DurationUnit_SECONDS_getInstance } from '../../../../../kotlin-kotlin-stdlib/kotlin/time/DurationUnitJs.mjs';
import { delay1yesbzthrp6ln as delay } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Delay.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_defaultRetryStrategy() {
  _init_properties_RetryOnErrorInterceptor_kt__m47hbi();
  return defaultRetryStrategy;
}
var defaultRetryStrategy;
var RetryStrategyClass;
function RetryStrategy() {
  if (RetryStrategyClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'RetryStrategy', VOID, VOID, VOID, [1]);
    RetryStrategyClass = $;
  }
  return RetryStrategyClass;
}
var RetryContextClass;
function RetryContext() {
  if (RetryContextClass === VOID) {
    class $ {
      constructor(networkMonitor, request) {
        this.x6b_1 = networkMonitor;
        this.y6b_1 = request;
        this.z6b_1 = 0;
      }
      b6c() {
        var tmp = this.a6c_1;
        if (!(tmp == null))
          return tmp;
        else {
          throwUninitializedPropertyAccessException('_response');
        }
      }
      h5m() {
        return this.b6c();
      }
      c6c() {
        this.z6b_1 = 0;
      }
      d6c() {
        return this.z6b_1;
      }
    }
    initMetadataForClass($, 'RetryContext');
    RetryContextClass = $;
  }
  return RetryContextClass;
}
function isRecoverable(_this__u8e3s4) {
  _init_properties_RetryOnErrorInterceptor_kt__m47hbi();
  var tmp;
  if (_this__u8e3s4 instanceof ApolloNetworkException()) {
    tmp = true;
  } else {
    if (_this__u8e3s4 instanceof ApolloWebSocketClosedException()) {
      tmp = true;
    } else {
      tmp = false;
    }
  }
  return tmp;
}
function RetryOnErrorInterceptor(networkMonitor, retryStrategy) {
  networkMonitor = networkMonitor === VOID ? null : networkMonitor;
  retryStrategy = retryStrategy === VOID ? get_defaultRetryStrategy() : retryStrategy;
  _init_properties_RetryOnErrorInterceptor_kt__m47hbi();
  return new (DefaultRetryOnErrorInterceptorImpl())(networkMonitor, retryStrategy);
}
var DefaultRetryOnErrorInterceptorImpl$intercept$slambdaClass;
function DefaultRetryOnErrorInterceptorImpl$intercept$slambda() {
  if (DefaultRetryOnErrorInterceptorImpl$intercept$slambdaClass === VOID) {
    class $ {
      constructor($failFastIfOffline, this$0, $request, $downstream) {
        this.e6c_1 = $failFastIfOffline;
        this.f6c_1 = this$0;
        this.g6c_1 = $request;
        this.h6c_1 = $downstream;
      }
      *i6c($this$flow, $completion) {
        var tmp;
        if (this.e6c_1) {
          var tmp0_safe_receiver = this.f6c_1.j6c_1;
          var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.l6c();
          tmp = (tmp1_safe_receiver == null ? null : tmp1_safe_receiver.n3()) === false;
        } else {
          tmp = false;
        }
        if (tmp) {
          yield* $this$flow.a1e(Builder().s45(this.g6c_1.r44_1, this.g6c_1.s44_1).x45(ApolloOfflineException().k4h()).l38(), $completion);
        } else {
          yield* emitAll($this$flow, this.h6c_1, $completion);
        }
        return Unit_instance;
      }
      od(p1, $completion) {
        return this.i6c((!(p1 == null) ? isInterface(p1, FlowCollector()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    DefaultRetryOnErrorInterceptorImpl$intercept$slambdaClass = $;
  }
  return DefaultRetryOnErrorInterceptorImpl$intercept$slambdaClass;
}
function DefaultRetryOnErrorInterceptorImpl$intercept$slambda_0($failFastIfOffline, this$0, $request, $downstream) {
  var i = new (DefaultRetryOnErrorInterceptorImpl$intercept$slambda())($failFastIfOffline, this$0, $request, $downstream);
  var l = ($this$flow, $completion) => i.i6c($this$flow, $completion);
  l.$arity = 1;
  return l;
}
var DefaultRetryOnErrorInterceptorImpl$intercept$slambdaClass_0;
function DefaultRetryOnErrorInterceptorImpl$intercept$slambda_1() {
  if (DefaultRetryOnErrorInterceptorImpl$intercept$slambdaClass_0 === VOID) {
    class $ {
      constructor($state, this$0) {
        this.m6c_1 = $state;
        this.n6c_1 = this$0;
      }
      *r67(it, $completion) {
        this.m6c_1.a6c_1 = it;
        if (yield* this.n6c_1.k6c_1.w6b(this.m6c_1, $completion)) {
          var _receiver__tnumb7 = this.m6c_1;
          _receiver__tnumb7.z6b_1 = _receiver__tnumb7.z6b_1 + 1 | 0;
          throw RetryException().q6c();
        }
        return Unit_instance;
      }
      od(p1, $completion) {
        return this.r67(p1 instanceof ApolloResponse() ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    DefaultRetryOnErrorInterceptorImpl$intercept$slambdaClass_0 = $;
  }
  return DefaultRetryOnErrorInterceptorImpl$intercept$slambdaClass_0;
}
function DefaultRetryOnErrorInterceptorImpl$intercept$slambda_2($state, this$0) {
  var i = new (DefaultRetryOnErrorInterceptorImpl$intercept$slambda_1())($state, this$0);
  var l = (it, $completion) => i.r67(it, $completion);
  l.$arity = 1;
  return l;
}
var DefaultRetryOnErrorInterceptorImpl$intercept$slambdaClass_1;
function DefaultRetryOnErrorInterceptorImpl$intercept$slambda_3() {
  if (DefaultRetryOnErrorInterceptorImpl$intercept$slambdaClass_1 === VOID) {
    class $ {
      *r6c($this$retryWhen, cause, _unused_var__etf5q3, $completion) {
        var tmp;
        if (cause instanceof RetryException()) {
          tmp = true;
        } else {
          tmp = false;
        }
        return tmp;
      }
      d5y(p1, p2, p3, $completion) {
        var tmp = (!(p1 == null) ? isInterface(p1, FlowCollector()) : false) ? p1 : THROW_CCE();
        var tmp_0 = p2 instanceof Error ? p2 : THROW_CCE();
        return this.r6c(tmp, tmp_0, (!(p3 == null) ? typeof p3 === 'bigint' : false) ? p3 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [3]);
    DefaultRetryOnErrorInterceptorImpl$intercept$slambdaClass_1 = $;
  }
  return DefaultRetryOnErrorInterceptorImpl$intercept$slambdaClass_1;
}
function DefaultRetryOnErrorInterceptorImpl$intercept$slambda_4() {
  var i = new (DefaultRetryOnErrorInterceptorImpl$intercept$slambda_3())();
  var l = ($this$retryWhen, cause, _unused_var__etf5q3, $completion) => i.r6c($this$retryWhen, cause, _unused_var__etf5q3, $completion);
  l.$arity = 3;
  return l;
}
var DefaultRetryOnErrorInterceptorImplClass;
function DefaultRetryOnErrorInterceptorImpl() {
  if (DefaultRetryOnErrorInterceptorImplClass === VOID) {
    class $ {
      constructor(networkMonitor, retryStrategy) {
        this.j6c_1 = networkMonitor;
        this.k6c_1 = retryStrategy;
      }
      s6b(request, chain) {
        var tmp0_elvis_lhs = request.e45_1;
        var failFastIfOffline = tmp0_elvis_lhs == null ? false : tmp0_elvis_lhs;
        var state = new (RetryContext())(this.j6c_1, request);
        var downstream = chain.r6b(request);
        var tmp = flow(DefaultRetryOnErrorInterceptorImpl$intercept$slambda_0(failFastIfOffline, this, request, downstream));
        var tmp_0 = onEach(tmp, DefaultRetryOnErrorInterceptorImpl$intercept$slambda_2(state, this));
        return retryWhen(tmp_0, DefaultRetryOnErrorInterceptorImpl$intercept$slambda_4());
      }
    }
    initMetadataForClass($, 'DefaultRetryOnErrorInterceptorImpl');
    DefaultRetryOnErrorInterceptorImplClass = $;
  }
  return DefaultRetryOnErrorInterceptorImplClass;
}
var RetryExceptionClass;
function RetryException() {
  if (RetryExceptionClass === VOID) {
    class $ extends Exception() {
      static q6c() {
        var $this = this.xd('Retry');
        captureStack($this, $this.p6c_1);
        return $this;
      }
    }
    initMetadataForClass($, 'RetryException', $.q6c);
    RetryExceptionClass = $;
  }
  return RetryExceptionClass;
}
var sam$com_apollographql_apollo_interceptor_RetryStrategy$0Class;
function sam$com_apollographql_apollo_interceptor_RetryStrategy$0() {
  if (sam$com_apollographql_apollo_interceptor_RetryStrategy$0Class === VOID) {
    class $ {
      constructor(function_0) {
        this.s6c_1 = function_0;
      }
      *w6b(context, $completion) {
        return yield* this.s6c_1(context, $completion);
      }
      i5() {
        return this.s6c_1;
      }
      equals(other) {
        var tmp;
        if (!(other == null) ? isInterface(other, RetryStrategy()) : false) {
          var tmp_0;
          if (!(other == null) ? isInterface(other, FunctionAdapter()) : false) {
            tmp_0 = equals(this.i5(), other.i5());
          } else {
            tmp_0 = false;
          }
          tmp = tmp_0;
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return hashCode(this.i5());
      }
    }
    initMetadataForClass($, 'sam$com_apollographql_apollo_interceptor_RetryStrategy$0', VOID, VOID, [RetryStrategy(), FunctionAdapter()], [1]);
    sam$com_apollographql_apollo_interceptor_RetryStrategy$0Class = $;
  }
  return sam$com_apollographql_apollo_interceptor_RetryStrategy$0Class;
}
var defaultRetryStrategy$slambdaClass;
function defaultRetryStrategy$slambda() {
  if (defaultRetryStrategy$slambdaClass === VOID) {
    class $ {
      *t6c(state, $completion) {
        var request = state.y6b_1;
        var exception = state.h5m().d46_1;
        if (!(request.d45_1 === true) || exception == null) {
          return false;
        }
        if (exception instanceof ApolloOfflineException()) {
          var tmp = request.r44_1;
          if (isInterface(tmp, Subscription())) {
            yield* waitForNetwork(ensureNotNull(state.x6b_1), $completion);
            state.c6c();
            return true;
          } else {
            return false;
          }
        }
        if (isRecoverable(exception)) {
          var tmp_0;
          var tmp_1 = request.r44_1;
          if (!isInterface(tmp_1, Subscription())) {
            tmp_0 = state.d6c() >= 3;
          } else {
            tmp_0 = false;
          }
          if (tmp_0) {
            return false;
          }
          Companion_getInstance();
          // Inline function 'kotlin.math.pow' call
          var n = state.d6c();
          var tmp$ret$0 = Math.pow(2.0, n);
          // Inline function 'kotlin.time.Companion.seconds' call
          var this_0 = coerceAtMost(tmp$ret$0, 60.0);
          var tmp$ret$1 = toDuration(this_0, DurationUnit_SECONDS_getInstance());
          yield* delay(tmp$ret$1, $completion);
          return true;
        }
        return false;
      }
      od(p1, $completion) {
        return this.t6c(p1 instanceof RetryContext() ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    defaultRetryStrategy$slambdaClass = $;
  }
  return defaultRetryStrategy$slambdaClass;
}
function defaultRetryStrategy$slambda_0() {
  var i = new (defaultRetryStrategy$slambda())();
  var l = (state, $completion) => i.t6c(state, $completion);
  l.$arity = 1;
  return l;
}
var properties_initialized_RetryOnErrorInterceptor_kt_exnoek;
function _init_properties_RetryOnErrorInterceptor_kt__m47hbi() {
  if (!properties_initialized_RetryOnErrorInterceptor_kt_exnoek) {
    properties_initialized_RetryOnErrorInterceptor_kt_exnoek = true;
    var tmp = defaultRetryStrategy$slambda_0();
    defaultRetryStrategy = new (sam$com_apollographql_apollo_interceptor_RetryStrategy$0())(tmp);
  }
}
//region block: exports
export {
  RetryOnErrorInterceptor as RetryOnErrorInterceptor2wqvvqzzzk2ot,
};
//endregion

//# sourceMappingURL=RetryOnErrorInterceptor.mjs.map
